"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanyBaseModel = exports.BaseModel = void 0;
/**
 * Base model that provides common fields and functionality
 * Equivalent to Java's BaseModel
 */
class BaseModel {
    constructor() {
        this.created = Date.now();
        this.modified = Date.now();
        this.deleted = false;
        this.updated = false;
        const now = Date.now();
        this.created = now;
        this.modified = now;
        this.deleted = false;
        this.updated = false;
    }
    /**
     * Prepare method for initialization logic
     * Can be overridden by subclasses
     */
    prepare() {
        // Default implementation - can be overridden
        if (this.id) {
            this.created = Date.now();
            this.modified = Date.now();
            this.deleted = false;
        }
        else {
            if (this.updated) {
                this.modified = Date.now();
                this.updated = false;
            }
        }
    }
}
exports.BaseModel = BaseModel;
/**
 * Company-scoped base model
 * Equivalent to Java's CompanyBaseModel
 */
class CompanyBaseModel extends BaseModel {
    constructor() {
        super();
    }
    /**
     * Prepare with company ID
     * @param companyId The company ID to set
     */
    prepare(companyId) {
        if (companyId) {
            this.companyId = companyId;
        }
        // Call parent prepare
        super.prepare();
    }
    /**
     * Reset and prepare with company ID
     * @param companyId The company ID to set
     */
    resetPrepare(companyId) {
        this.companyId = companyId;
        this.prepare();
    }
}
exports.CompanyBaseModel = CompanyBaseModel;
//# sourceMappingURL=BaseModels.js.map